import * as React from 'react';

import { Row as AntRow, Tooltip } from 'antd';
import { Ellipsis } from 'antd-mobile';
import {
  CheckCircleOutlined,
  Column,
  LoadingOutlined,
  Modal,
  RetweetOutlined,
  Row,
  Space,
  Text,
} from 'farmhub-ui-core';
import { useHistory } from 'react-router-dom';

import { useAppSelector } from 'app';
import { InfoCard, TitleText } from 'components';
import { ArrowLeftIcon, TimeWaitingIcon } from 'components/Icon';
import { theme } from 'styled';
import { DOMAIN_STATUS, formatWebsite, SIZE } from 'utils';

import { CButton, CButtonBack, InfoCartWrapper, DomainWrapper } from './styles';

interface AccountModalProps {
  isToggle: boolean;
  height?: number;
  listStep: any[];
  visible: boolean;
  entityType: string;
  isSelecting: boolean;
  currentStep: number;
  handleChangeVisible: (e: boolean) => void;
  handleChangeEntityType: (e: string) => void;
  handleChangeCurrentStep: (e: number) => void;
  renderEntityName: (e: string) => React.ReactNode;
}

const AccountModalDesktop = ({
  visible,
  isToggle,
  height = 42,
  listStep,
  entityType,
  isSelecting,
  currentStep,
  renderEntityName,
  handleChangeVisible,
  handleChangeEntityType,
  handleChangeCurrentStep,
}: AccountModalProps): JSX.Element => {
  const history = useHistory();
  const entity = useAppSelector(state => state.account.item);

  const rejectToggle = React.useMemo(
    () =>
      location.pathname.includes('/sale/#') ||
      location.pathname.includes('/sale/balance') ||
      location.pathname.includes('/production-plan/report-quantity') ||
      location.pathname.includes('/production-plan/task') ||
      location.pathname.includes('/purchase/order-chain-supplier') ||
      location.pathname.includes('/sale/quick-forecast'),
    [history.location.pathname]
  );

  return (
    <>
      <CButton height={height} onClick={() => handleChangeVisible(true)}>
        <Row justifyContent="space-between">
          <Row alignItems="center">
            <InfoCartWrapper
              alignItems="flex-start"
              height="100%"
              width="fit-content"
            >
              <InfoCard
                entityType={entity?.type}
                img={entity?.avatar}
                name=" "
                size={SIZE.SMALL}
                width="fit-content"
              />
            </InfoCartWrapper>

            {(isToggle || rejectToggle) && (
              <Column styles={{ height: 'fit-content' }} width="100%">
                <Tooltip title={entity?.displayName}>
                  <Text
                    color="dark"
                    lineHeight="18px"
                    lineNumber={1}
                    size="xxs"
                    styles={{ textAlign: 'start' }}
                    weight="bold"
                  >
                    {entity?.displayName}
                  </Text>
                </Tooltip>

                <Row alignItems="center" height="fit-content" width="100%">
                  {entity?.domain ? (
                    <>
                      <DomainWrapper alignItems="center">
                        <Tooltip title={entity?.domain}>
                          <Text
                            color="main"
                            lineHeight="16px"
                            lineNumber={1}
                            size="xxs"
                            style={{
                              width: '100%',
                              textAlign: 'left',
                              cursor: 'pointer',
                              color: theme.colors.success,
                            }}
                          >
                            {entity?.domain ? (
                              <Ellipsis
                                content={formatWebsite(entity?.domain)}
                                direction="end"
                              />
                            ) : (
                              ''
                            )}
                          </Text>
                        </Tooltip>

                        <Space width={3} />
                        {entity?.domainStatus == DOMAIN_STATUS.ACTIVATE ? (
                          <Column width="fit-content">
                            <Tooltip title="Đã kích hoạt">
                              <CheckCircleOutlined
                                className="check-out-line"
                                color={theme.colors.primary.main}
                              />
                            </Tooltip>
                          </Column>
                        ) : (
                          <Tooltip title="Chưa kích hoạt">
                            <Column width="fit-content">
                              <TimeWaitingIcon
                                className="check-out-line"
                                height={12}
                                width={12}
                              />
                            </Column>
                          </Tooltip>
                        )}
                      </DomainWrapper>
                    </>
                  ) : entity?.website ? (
                    <Tooltip title={entity.suggestDomain}>
                      <Text
                        color="main"
                        lineHeight="16px"
                        lineNumber={1}
                        size="xxs"
                        style={{
                          cursor: 'pointer',
                          color: theme.colors.success,
                        }}
                      >
                        <Ellipsis
                          content={formatWebsite(entity.suggestDomain)}
                          direction="end"
                        />
                      </Text>
                    </Tooltip>
                  ) : (
                    <Text
                      color="secondary"
                      lineHeight="16px"
                      size="xxs"
                      styles={{ fontStyle: 'italic' }}
                    >
                      Chưa thiết lập
                    </Text>
                  )}
                </Row>
              </Column>
            )}
          </Row>
          <Space width={4} />
          {isToggle &&
            (isSelecting ? (
              <LoadingOutlined spin style={{ fontSize: 16 }} />
            ) : (
              <RetweetOutlined
                className="icon"
                style={{ fontSize: 16, color: theme.colors.primary.main }}
              />
            ))}
        </Row>
      </CButton>

      <Modal
        centered
        bodyHeight={currentStep !== 0 ? '640px' : '710px'}
        footer={null}
        title={
          currentStep !== 0 ? (
            <Row justifyContent="center">
              <Space height={28} />
              <CButtonBack
                onClick={() => {
                  handleChangeCurrentStep(currentStep - 1);
                  handleChangeEntityType('farm');
                }}
              >
                <ArrowLeftIcon className="icon" height={12} width={12} />
              </CButtonBack>
              <TitleText color="dark">
                {currentStep === 1 && 'Chọn loại thực thể'}
                {currentStep === 2 && renderEntityName(entityType)}
              </TitleText>
            </Row>
          ) : null
        }
        visible={visible}
        width={
          currentStep === 0
            ? '600px'
            : (entityType === 'transport' && currentStep !== 1) ||
              (entityType === 'warehouse' && currentStep !== 1) ||
              (entityType === 'volunteer' && currentStep !== 1)
            ? 'auto'
            : '1000px'
        }
        onCancel={() => handleChangeVisible(false)}
        onOk={() => handleChangeVisible(false)}
      >
        <AntRow justify="center" style={{ height: '100%' }}>
          {listStep[currentStep]}
        </AntRow>
      </Modal>
    </>
  );
};

export default AccountModalDesktop;
